require('angular-bootstrap-npm');
require('angular-resource');
require('angular-cookies');
require('ng-file-upload');
require('lodash');
require('angular-moment');
require('ng-idle');

const app = angular.module('app', [
  'ngRoute', 'ngResource', 'ngSanitize', 'ngCookies', 'ui.select', 'ui.bootstrap', 'ngFileUpload', 'angularMoment',
  'ngIdle', 'ui.grid', 'ui.grid.pagination', 'ui.grid.selection', 'ui.sortable',
  require('./components/lbaRouteRoot/lbaRouteRoot').name,
  require('./components/lbaGrid').name,
  require('./components/lbaGridItem').name,
  require('./components/lbaDynamic').name,
  require('./components/lbaResource').name,
  require('./components/lbaSubHeading').name,
  require('./components/lbaTabs').name,
  require('./components/lbaGroup').name,
  require('./components/lbaTextInput').name,
  require('./components/lbaToast').name,
  require('./components/lbaNav').name,
  require('./components/lbaLoader').name,
  require('./components/lbaAddGridResource').name,
  require('./components/lbaBoolean').name,
  require('./components/lbaCountrySelect').name,
  require('./components/lbaTagInput').name,
  require('./components/lbaFileUploader').name,
  require('./components/lbaFileDownloader').name,
  require('./components/lbaSelect').name,
  require('./components/lbaODataIndexMultiSelect').name,
  require('./components/lbaMultiSelect').name,
  require('./components/lbaKeyValuePair').name,
  require('./components/lbaRange').name,
  require('./components/lbaBreadCrumb').name,
  require('./components/lbaHotel').name,
  require('./components/lbaPointsOfInterest').name,
  require('./components/lbaRedirect/lbaRedirect').name,
  require('./components/lbaSearchBy').name,
  require('./components/lbaTextArea').name,
  require('./components/lbaODataSelect').name,
  require('./components/lbaTimeZoneSelect').name,
  require('./components/lbMap').name,
  require('./components/lbaSubNav/lbaSubNav').name,
  require('./components/lbaLatLongMapSearch').name,
  require('./components/lbaLatLngMap').name,
  require('./components/lbaViewGrid').name,
  require('./components/lbaBooleanRestrictionSelect').name,
  require('./components/lbaFareClassTypeSelect'),
  require('./components/lbaCompanyReference').name,
  require('./components/lbaPerdiem').name,
  require('./components/lbaPerdiemGridItem').name,
  require('./components/lbaPerDiemFileUploader').name,
  require('./components/lbaTestFtpConnection').name,
  require('./components/lbaPagingGrid').name,
  require('./components/lbaEnhancedLogItem').name,
  require('./components/lbaCompanyReferenceConfigAuditItem').name,
  require('angular-auth0'),
]);

app.config(require('./config/routerConfig')(app));
app.config(require('./config/authConfig')(app));

app.config([
  'angularAuth0Provider',
  (angularAuth0Provider) => {
    angularAuth0Provider.init({
      clientID: auth0Config.ClientId,
      domain: auth0Config.Domain,
      responseType: 'token id_token',
      audience: auth0Config.ApiIdentifier,
      scope: auth0Config.Scope,
      redirectUri: auth0Config.Callback,
    });
  },
]);

app.constant('AUTH_EVENTS', require('./constants/authConstants'));
app.factory('authInterceptor', require('./factories/authInterceptor'));
app.service('authService', require('./services/authService'));
app.service('settingsService', require('./services/settingsService'));
app.service('dataService', require('./services/dataService'));
app.service('indexService', require('./services/indexService'));
app.service('subNavService', require('./services/subNavService'));
app.service('dataSourceService', require('./services/dataSourceService'));
app.service('microApiService', require('./services/microApiService'));
app.service('formValidationService', require('./services/formValidationService'));
app.service('authCallbackService', require('./components/lbaAuth0Authenticate/authCallbackService'));
app.directive('clickOutside', require('./components/lbaClickOutside'));


app.run(['$injector', $injector => {
  app.register = $injector.loadModule.bind($injector);
}]);

app.run(['$templateCache', $templateCache => {
  $templateCache.put('gridPaginationTpl.html', require('./templates/gridPaginationTpl.html'));
}]);

app.run(['$rootScope', '$location', 'authService', 'dataService','authCallbackService', ($rootScope, $location, authService, dataService,authCallbackService) =>
  $rootScope.$on('$routeChangeStart', function (event, next, current) {
    authCallbackService.checkCallBack();
    
    // Fix for grid add item memory issue: Always clean data when in addNewMode
    if (dataService.addNewMode || dataService.cleanDataOnRouteChange) {
      // Check if we're navigating to a different section entirely
      const nextPath = next ? next.$$route.originalPath : '';
      const backPath = dataService.backPath || '';
      
      // If navigating to a completely different top-level section, clear addNewMode and let new page load normally
      // Compare the first non-empty segment of each path (e.g., 'enhanced-policy-rules')
      const nextRoot = nextPath ? nextPath.split('/')[1] : '';
      const backRoot = backPath ? backPath.split('/')[1] : '';
      if (nextRoot && backRoot && nextRoot !== backRoot) {
        dataService.addNewMode = false;
        dataService.addNewBackup = undefined;
        dataService.cleanDataOnRouteChange = false;
        return;
      }
      
      // Allow the initial transition from grid -> item edit page to proceed without cleanup.
      // lbaResourceCtrl sets cleanDataOnRouteChange = true on load. So if we're in addNewMode but
      // cleanDataOnRouteChange is not yet true, we're likely entering the item page; do nothing.
      if (dataService.addNewMode && !dataService.cleanDataOnRouteChange) {
        return;
      }
       
       // Ensure dataService.data exists and has proper structure
       if (!dataService.data) {
         dataService.data = { activeItem: undefined, items: [] };
       }
       
       // Restore from backup safely if backup exists
       if (dataService.addNewBackup) {
         if (dataService.addNewBackup.activeItem !== undefined) {
           dataService.data.activeItem = angular.copy(dataService.addNewBackup.activeItem);
         }
         if (dataService.addNewBackup.items) {
           dataService.data.items = angular.copy(dataService.addNewBackup.items);
         }
       }
       
       // Exit Add New mode and clear flags when navigating away from the item page
       dataService.addNewMode = false;
       dataService.addNewBackup = undefined;
       dataService.cleanDataOnRouteChange = false;
       return;
     }
    if (next.$$route && (next.$$route.originalPath === '/access-denied' || next.$$route.originalPath === '/loginForm')){
      return;
    }
    if (!authService.isAuthenticated()) {
      if (next.$$route && next.$$route.originalPath !== '/login' && next.$$route.originalPath !== '/loginForm' && next.$$route.originalPath !== '/logout' && next.$$route.originalPath !== '/access-denied') {
        localStorage.setItem('previousState', $location.$$path);
        authService.prevRoute = $location.path();
        event.preventDefault();
        $location.path('/login');
      }
    }
 
    authService.isAuthorized().then((isAuth)=>{
      if(!isAuth){
        $location.path('/access-denied');
      }
    });
  
  })
]);

app.run(['$rootScope', '$location', 'AUTH_EVENTS', 'authService', ($rootScope, $location, AUTH_EVENTS, authService) =>
  $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
    if (authService.prevRoute) {
      $location.path(authService.prevRoute);
    } else {
      $location.path('/');
    }
  })
]);

app.run(['$rootScope', '$location', 'AUTH_EVENTS', ($rootScope, $location, AUTH_EVENTS) =>
  $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
    $location.path('/login');
  })
]);

app.run(['$rootScope', '$location', 'AUTH_EVENTS', ($rootScope, $location, AUTH_EVENTS) =>
  $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
    $location.path('/login');
  })
]);

app.run(['Idle', function (Idle) {
  Idle.watch();
}]);

app.config(['KeepaliveProvider', 'IdleProvider', function (KeepaliveProvider, IdleProvider) {
  IdleProvider.idle(19 * 60);
  IdleProvider.timeout(1);
}])
  .run(['$rootScope', 'authService', 'AUTH_EVENTS', ($rootScope, authService, AUTH_EVENTS) => {
    $rootScope.$on('IdleTimeout', function () {
      authService.logout().then(function () {
        $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
      });
    });
  }]);


export default app;



// WEBPACK FOOTER //
// ./src/app.js